import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const whatsappNumber = '94707352969';
  const message = encodeURIComponent("Hi, I'm interested in your vehicles!");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <a 
      href={whatsappLink}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
